import { isNonNullable, isNullable } from '@ipfabric/utils';
import get from 'lodash/get';
import { assoc, pipe } from 'ramda';
import { normalizeToSlug } from 'utils/slug';

const graphKeyToColor = (severity) => {
  switch (severity.toString()) {
    case '0':
      return 'ok';
    case '10':
      return 'info';
    case '20':
      return 'warning';
    case '30':
      return 'critical';
    default:
      return severity;
  }
};

const getReportValue = (
  checks,
  key,
  weight,
  totalResultsPerRow,
  inAbsoluteValue,
  acc,
) => {
  if (inAbsoluteValue) {
    return isNonNullable(checks[key])
      ? acc[key] + Number(checks[key]) * weight
      : acc[key];
  }
  return isNonNullable(checks[key])
    ? acc[key] + (Number(checks[key]) / totalResultsPerRow) * 100 * weight
    : acc[key];
};

export function getGraphData(foundGroup, reportsMap, inAbsoluteValue) {
  const getData = (child) => {
    const report = reportsMap[child.id];
    if (isNullable(report?.result) || report.status !== 1) {
      return { results: null, totalResults: null, weight: null };
    }
    const weight = Number(child.weight);
    const results = get(report, 'result.checks') || {};
    const totalResults = Object.keys(results).reduce((accChecks, key) => {
      const val = results[key];
      return isNonNullable(val) ? accChecks + Number(val) : accChecks;
    }, 0);
    return { results, totalResults, weight };
  };

  const foundResults = pipe(
    () =>
      foundGroup.children.reduce(
        (acc, child) => {
          const { results, totalResults, weight } = getData(child);
          if (!totalResults) {
            return acc;
          }
          return pipe(
            assoc(
              '30',
              getReportValue(
                results,
                '30',
                weight,
                totalResults,
                inAbsoluteValue,
                acc,
              ),
            ),
            assoc(
              '20',
              getReportValue(
                results,
                '20',
                weight,
                totalResults,
                inAbsoluteValue,
                acc,
              ),
            ),
            assoc(
              '10',
              getReportValue(
                results,
                '10',
                weight,
                totalResults,
                inAbsoluteValue,
                acc,
              ),
            ),
            assoc(
              '0',
              getReportValue(
                results,
                '0',
                weight,
                totalResults,
                inAbsoluteValue,
                acc,
              ),
            ),
          )(acc);
        },
        {
          0: 0,
          10: 0,
          20: 0,
          30: 0,
        },
      ),
    (resultMap) =>
      Object.keys(resultMap).reduce((acc, key) => {
        return assoc(graphKeyToColor(key), resultMap[key], acc);
      }, {}),
  )();

  const total = inAbsoluteValue
    ? foundGroup.children.reduce((acc, child) => {
        const { totalResults, weight } = getData(child);
        return acc + totalResults * weight;
      }, 0) || 1
    : Object.keys(foundResults).reduce((acc, key) => {
        const value = foundResults[key];
        return acc + value;
      }, 0) || 1;

  return Object.keys(foundResults).reduce((acc, key) => {
    const value = foundResults[key];
    if (value === 0) {
      return acc;
    }
    return assoc(
      key,
      pipe(
        (v) => (v / total) * 100,
        (v) => (v % 1 === 0 ? v : Math.floor(v * 100) / 100),
      )(value),
      acc,
    );
  }, {});
}

export function normalizeToLayoutSlug(input) {
  return `${normalizeToSlug(input)}-layout`;
}

export const initialLayout = {
  rows: [],
};
